import React, { useEffect } from 'react';
import strings from '../../utils/strings';
import { Statistic, Row, Col, Card, Spin } from 'antd';
import {
    ContactsOutlined,
    FileTextOutlined,
    ShoppingFilled,
    CreditCardOutlined
} from '@ant-design/icons';
import { usePersistedStore } from '../../store/persisted-store';
import { useReportsStore } from '../../store/slices/createReportsSlice';

export default function Summary() {
    const { business } = usePersistedStore();
    const reports = useReportsStore()
    const data = reports.summary.data;
    const loading = reports.summary.loading;
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;

    useEffect(() => {
        reports.getSummary()
    }, [token]) // eslint-disable-line react-hooks/exhaustive-deps

    return (

        <Row gutter={[16, 16]}>
            <Col span={4}>
                <Spin spinning={loading}>
                    <Card size="small">
                        <Statistic
                            prefix={<ContactsOutlined />}
                            title="تعداد کاربران"
                            value={strings.getFarsiNum(data?.Cndtser)} />
                    </Card>
                </Spin>
            </Col>
            <Col span={4}>
                <Spin spinning={loading}>
                    <Card size="small">
                        <Statistic
                            prefix={<FileTextOutlined />}
                            title="تعداد استعلام"
                            value={strings.getFarsiNum(data?.Cndtser)}
                        />
                    </Card>
                </Spin>
            </Col>
            <Col span={4}>
                <Spin spinning={loading}>
                    <Card size="small">
                        <Statistic
                            prefix={<ShoppingFilled />}
                            title="تعداد بیمه نامه صادر شده"
                            value={strings.getFarsiNum(data?.CntSaled)}
                        />
                    </Card>
                </Spin>
            </Col>
            <Col span={4}>
                <Spin spinning={loading}>
                    <Card size="small">
                        <Statistic
                            prefix={<FileTextOutlined />}
                            title="درخواست‌های در دست بررسی"
                            value={strings.getFarsiNum((data?.CntPay - data.CntSaled))}
                        />
                    </Card>
                </Spin>
            </Col>
            <Col span={4}>
                <Spin spinning={loading}>
                    <Card size="small">
                        <Statistic
                            prefix={<CreditCardOutlined />}
                            title="جمع حق بیمه پرداختی"
                            value={strings.currencyFormat(data.SumPayableAmount ? data.SumPayableAmount : 0)}
                        />
                    </Card>
                </Spin>
            </Col>
            <Col span={4}>
                <Spin spinning={loading}>
                    <Card size="small">
                        <Statistic
                            prefix={<CreditCardOutlined />}
                            title="جمع حق بیمه"
                            value={strings.currencyFormat(data.SumActualAmount ? data.SumActualAmount : 0)}
                        />
                    </Card>
                </Spin>
            </Col>
        </Row>
    )
}